import { FC } from 'react'
import classNames from 'classnames'
import RouterLink from 'components/link'
// @ts-ignore
import Tappable from 'react-tappable'
import css from './OnboardingButtons.styles.scss'
import { InfoButton } from 'components/buttons'

// Potentially incomplete or incorrect
// Built off of Button.propTypes in components/buttons.jsx
interface InfoButtonProps {
  size?: string
  empty?: boolean
  type?: string
  style?: object
  href?: string
  id?: string
  className?: string
  onClick?: () => void
  disabled?: boolean
  submitting?: boolean
  block?: boolean
  target?: string
  rel?: string
  pill?: boolean
  circle?: boolean
  newWindow?: boolean
  selected?: boolean
  title?: string
  role?: string
  [k: string]: any
}

// Potentially incomplete or incorrect
// Built off of Link.propTypes in components/link.jsx
interface RouterLinkProps {
  className?: string
  newWindow?: boolean
  onClick?: () => void
  style?: object
  title?: string
  to?: string | object
  url?: string
  rel?: string
  routerVersion?: 3 | 4 | 6
  [k: string]: any
}

interface FilledButtonProps extends InfoButtonProps {}

const FilledButton: FC<FilledButtonProps> = ({ children, ...buttonProps }) => (
  <InfoButton {...buttonProps} block pill>
    {children}
  </InfoButton>
)

interface FilledLinkProps
  extends Pick<RouterLinkProps, 'to' | 'url' | 'onClick'> {
  [k: string]: any
}

const FilledLink: FC<FilledLinkProps> = ({
  children,
  to,
  url,
  onClick,
  ...buttonProps
}) => (
  <RouterLink to={to} url={url} onClick={onClick} routerVersion={4}>
    <div
      {...buttonProps}
      className={classNames(
        'btn btn-info btn-block btn-pill',
        css.continueButton
      )}
    >
      {children}
    </div>
  </RouterLink>
)

type NextButtonProps = FilledLinkProps | FilledButtonProps

export const NextButton: FC<NextButtonProps> = (props) => {
  const { to, url, className } = props

  return to || url ? (
    <FilledLink
      {...props}
      className={classNames(className, css.continueButton)}
    >
      Next
    </FilledLink>
  ) : (
    <FilledButton
      {...props}
      className={classNames(className, css.continueButton)}
    >
      Next
    </FilledButton>
  )
}

export const ButtonGroup: FC = ({ children }) => (
  <div
    role="radiogroup"
    aria-labelledby="onboardingQuestion"
    className={css.buttonGroup}
  >
    {children}
  </div>
)

interface ButtonRectProps {
  className?: string
  onClick: () => void
}

export const ButtonRect: FC<ButtonRectProps> = ({
  children,
  className,
  onClick,
}) => (
  <Tappable
    role="radio"
    className={classNames(css.buttonRect, className)}
    classes={{ active: css.buttonActive }}
    onTap={onClick}
    component="button"
  >
    <span className={css.buttonContent}>{children}</span>
  </Tappable>
)

interface ButtonRoundProps {
  onClick: () => void
}

export const ButtonRound: FC<ButtonRoundProps> = ({ children, onClick }) => (
  <Tappable
    role="radio"
    className={css.buttonRound}
    classes={{ active: css.buttonActive }}
    onTap={onClick}
    component="button"
  >
    <span className={css.buttonContent}>{children}</span>
  </Tappable>
)
